<template>
    <MDBBtn class="btn btn-primary w-10 px-5 mt-1" type="button" @click="emit('update:earlyPayoutModal', true)">
        Activate Now
    </MDBBtn>
    <MDBModal staticBackdrop scrollable id="earlyPayoutModal" tabindex="-1" labelledby="earlyPayoutModal"
        v-model="localEarlyPayoutModal">
        <MDBModalHeader class="px-4">
            <div class="d-block">
                <MDBModalTitle id="earlyPayoutModal" class="text-black fw-bold">
                    <template v-if="currentStep === 'main'">
                        Activate Early Pay
                    </template>
                    <template v-if="currentStep === 'terms'">
                        Terms of Agreement
                    </template>
                    <template v-if="currentStep === 'kyc'">
                        Identity Verification
                    </template>
                    <template v-if="currentStep === 'sign'">
                        Sign
                    </template>
                </MDBModalTitle>
                <template v-if="currentStep === 'main'">
                    <p class="mb-0 pe-2">Enabling this will override your current plan: <span
                            class="primary-text fw-bold">
                            Daily Payout
                        </span></p>
                </template>
                <template v-if="currentStep === 'terms'">
                    <p class="mb-0 pe-2">Before you complete your request, please read and accept the terms and
                        agreement
                        provided below.</p>
                </template>
                <template v-if="currentStep === 'kyc'">
                    <p class="mb-0 pe-2">To ensure security and compliance, please verify your identity by taking a live
                        selfie and uploading valid ID documents.</p>
                </template>
                <template v-if="currentStep === 'sign'">
                    <p class="mb-0 pe-2">By signing below, you confirm your request for an Early Payout and agree to the
                        terms and conditions of EnfiniPay.</p>
                </template>
            </div>
        </MDBModalHeader>
        <MDBModalBody class="d-flex flex-column gap-4 p-4">
            <template v-if="currentStep === 'main'">
                <div>
                    <p class="primary-text fw-bold">Get paid early for just 2.5% fee.</p>
                    <div>
                        <div class="d-flex gap-2 align-items-center">
                            <div class="primary-text">
                                <vue-feather type="check" :stroke-width="2.5" size="18px" />
                            </div>
                            <div>
                                <p class="fw-bold mb-1">~10 days earlier</p>
                                <p class="fs-7">The payout will be credited to your internal account details as soon as
                                    it
                                    becomes
                                    available
                                </p>
                            </div>
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                            <div class="primary-text">
                                <vue-feather type="check" :stroke-width="2.5" size="18px" />
                            </div>
                            <div>
                                <p class="fw-bold mb-1">Monthly subscription</p>
                                <p class="fs-7">Enable a subscription and automatically receive money ahead of schedule
                                </p>
                            </div>
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                            <div class="primary-text">
                                <vue-feather type="check" :stroke-width="2.5" size="18px" />
                            </div>
                            <div>
                                <p class="fw-bold mb-1">Flexible Settings</p>
                                <p class="fs-7">You can disable Auto Payout, select other details, or cancel your
                                    subscription
                                    at any
                                    time
                                </p>
                            </div>
                        </div>
                    </div>
                    <p class="fs-7 mb-0">Access your YouTube earnings 10 days before the official payout
                        date—automatically
                        added to your Internal Balance and ready for immediate withdrawal.</p>
                </div>
            </template>
            <template v-if="currentStep === 'terms'">
                <div class="border rounded-5 p-4">
                    <div style="max-height: 40vh; overflow: 
                    auto;">
                        <h6 className="fw-bold fs-6">Terms of Agreement: for Early Pay</h6>
                        <p>
                            By submitting an Early Pay request, you acknowledge and agree to
                            the following:
                        </p>
                        <h6 className="fw-bold fs-6">Overview</h6>
                        <p>
                            Early Pay allows you to receive a lump sum of your estimated
                            YouTube earnings before the standard payout period.
                        </p>
                        <div>
                            <h6 className="fw-bold fs-6">1. Advance Terms</h6>
                            <ul className="list-unstyled ps-3">
                                <li>The payout is based on your expected revenue.</li>
                                <li>
                                    A 2.5% service fee will be applied to the total advance.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">2. Approval Process</h6>
                            <p>
                                All requests are reviewed. Approval depends on your channel
                                performance, payout history, and compliance standing.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">3. Offset & Reconciliation</h6>
                            <p>
                                The advance will be deducted from your future YouTube payout.
                                If your actual earnings are lower than the advance, you may be
                                required to settle the remaining balance.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">4. Verification Requirements</h6>
                            <p>
                                Identity verification or documentation may be required. False
                                submissions may result in denial or account limitations.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">5. Not a Loan</h6>
                            <p>
                                This is an advance on your own projected income, not a loan.
                                You agree to use the funds responsibly.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">6. Policy Changes</h6>
                            <p>
                                VeryViralVideos may
                                revise these terms at any time. You’ll be notified of any key
                                changes prior to your next request.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold fs-6">7. Data Privacy Policy</h6>
                            <p class="mb-2">
                                VeryViralVideos collects and processes personal data such as government-issued ID,
                                financial information, and account details solely for the purposes of identity
                                verification, payout processing, and fraud prevention.
                            </p>
                            <p class="mb-2">
                                All personal data is securely stored and handled in accordance with applicable data
                                protection laws (e.g., the Philippine Data Privacy Act, GDPR if applicable).
                            </p>
                            <p class="mb-0">
                                Your information will not be sold or shared with third parties without your consent,
                                except where legally required.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-start gap-1 fw-bold" style="font-size: 15px;">
                    <!-- <input type="checkbox" v-model="localAgreement.tos" /> -->
                    <MDBCheckbox type="checkbox" :modelValue="localAgreement.tos"
                        @update:modelValue="val => localAgreement = { ...localAgreement, tos: val }" />
                    <span>I have read and agree to the above Terms of Agreement.</span>
                </div>
            </template>
            <template v-if="currentStep === 'kyc'">
                <VVVKyc v-model:agreement="localAgreement" />
            </template>
            <template v-if="currentStep === 'sign'">
                <h6>If you are under 18, your parent/guardian must sign on your behalf</h6>
                <VVVSignaturePad v-model:agreement="localAgreement" />
            </template>
        </MDBModalBody>
        <MDBModalFooter class="p-4">
            <template v-if="currentStep === 'main'">
                <MDBBtn class="btn btn-primary w-100 mx-auto" type="button"
                    @click="emit('update:currentStep', 'terms')">
                    <MDBIcon iconStyle="fas" icon="star" class="me-1" />
                    Activate to get these features
                </MDBBtn>
            </template>
            <template v-if="currentStep === 'terms'">
                <div class="d-flex align-items-center gap-3 w-100">
                    <MDBBtn class="fw-bold w-100 mx-auto shadow-3" type="button"
                        @click="emit('update:currentStep', 'main')">
                        Disagree
                    </MDBBtn>
                    <MDBBtn class="btn btn-primary w-100 mx-auto" type="button" @click="handleNext('kyc')">
                        Agree
                    </MDBBtn>
                </div>
            </template>
            <template v-if="currentStep === 'kyc'">
                <div class="d-flex align-items-center gap-3 w-100">
                    <MDBBtn class="fw-bold w-100 mx-auto shadow-3" type="button"
                        @click="emit('update:currentStep', 'terms')">
                        <MDBIcon iconStyle="fas" icon="arrow-left" class="me-1" />
                        Go Back
                    </MDBBtn>
                    <MDBBtn class="btn btn-primary w-100 mx-auto" type="button" @click="handleNext('sign')">
                        Next
                        <MDBIcon iconStyle="fas" icon="arrow-right" />
                    </MDBBtn>
                </div>
            </template>
            <template v-if="currentStep === 'sign'">
                <div class="d-flex align-items-center gap-3 w-100">
                    <MDBBtn class="fw-bold w-100 mx-auto shadow-3" type="button"
                        @click="emit('update:currentStep', 'kyc')">
                        <MDBIcon iconStyle="fas" icon="arrow-left" class="me-1" />
                        Go Back
                    </MDBBtn>
                    <MDBBtn class="btn btn-primary w-100 mx-auto" type="button" @click="activateEarlyPay"
                        :disabled="isActivating">
                        <template v-if="isActivating">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Processing...
                        </template>
                        <template v-else>
                            <MDBIcon iconStyle="fas" icon="check" />
                            Submit
                        </template>
                    </MDBBtn>
                </div>
            </template>
        </MDBModalFooter>
    </MDBModal>
</template>

<script setup>
import {
    MDBBtn,
    MDBCheckbox,
    MDBIcon,
    MDBModal, MDBModalBody,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle
} from "mdb-vue-ui-kit";
import { computed, defineEmits, defineProps, ref, watch } from 'vue';
import VueFeather from 'vue-feather';

import VVVKyc from "./VVVKyc.vue";
import VVVSignaturePad from "./VVVSignaturePad.vue";

const props = defineProps({
    successToast: Object,
    errorToast: Object,
    getSubscription: Function,
    isActivating: Boolean,
    activateEarlyPay: Function,
    earlyPayoutModal: Boolean,
    currentStep: String,
    agreement: Object
})

const emit = defineEmits([
    "trigger-success-toast",
    "trigger-error-toast",
    'update:earlyPayoutModal',
    'update:currentStep',
    "update:agreement"
]);

const localEarlyPayoutModal = computed({
    get: () => props.earlyPayoutModal,
    set: (val) => emit('update:earlyPayoutModal', val)
});

const localAgreement = computed({
    get: () => props.agreement,
    set: (val) => emit('update:agreement', val)
});

const currentStep = ref(props.currentStep);
watch(() => props.currentStep, (val) => {
    currentStep.value = val;
});

const handleNext = (step) => {
    if (step === 'kyc') {
        if (!localAgreement.value.tos) {
            emit("trigger-error-toast", {
                show: true,
                title: "Terms and Conditions",
                message: "Please agree to the terms and conditions to proceed with your advance payout request"
            });
            return;
        }
        emit('update:currentStep', 'kyc');
    }

    if (step === 'sign') {
        if (!localAgreement.value.selfie) {
            emit("trigger-error-toast", {
                show: true,
                title: "Verification Needed",
                message: "Please upload a clear selfie for identity verification"
            });
            return;
        }

        if (!localAgreement.value.uploadedId || localAgreement.value.uploadedId.length === 0) {
            emit("trigger-error-toast", {
                show: true,
                title: "ID Required",
                message: "Please upload a valid government-issued ID for verification"
            });
            return;
        }

        emit('update:currentStep', 'sign');
    }
}
</script>

<style scoped>
:root {
    --white: #ffffff;
    --primary: #223698;
    --secondary: #e2e6ef;
    --accent: #02061b;
    --blue: #1f87fc;
    --mdb-primary: var(--primary);
}

.btn-primary {
    background-color: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.btn-outline-primary {
    color: var(--primary);
    border-color: var(--primary)
}

.border-primary {
    border-color: var(--primary);
}

#table-container {
    flex: 1 1 auto;
    max-height: 35vh;
}

.image-container {
    position: relative;
    display: inline-block;
}

.image-container .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 45px;
    height: 45px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--primary);
    border-radius: 50%;
    animation: BorderSpin 1s linear infinite;
}

.image-container img {
    display: block;
    width: 45px;
    height: 45px;
    border-radius: 50%;
}
</style>
